/** @format */

import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { AddToBasket } from './pages'

import './common.css'

function App(props) {
  const renderRoute = (Component: React.FC<any>) => (routeProps: any) => (
    <Component {...props} {...routeProps} />
  )

  return (
    <div className="container">
      <Router>
        <Switch>
          <Route path="/" render={renderRoute(AddToBasket)} />
        </Switch>
      </Router>
    </div>
  )
}

export default App
